<template>
    <v-form v-model="valid">
        <v-card flat class="fill-height">
            <v-card-title class="pt-1 pb-0 ">
                <provider-title title="Cuenta de Cobro"/>
            </v-card-title>
            <v-alert v-if="!isOwner" type="info" outline color="secondary" class="body-1">
                Solo el dueño de la cuenta tiene acceso a esta pantalla
            </v-alert>
            <v-card-text v-else>

                <!-- SIN PLAN CON COBRO ONLINE -->
                <div class="text-xs-center my-4" v-if="!allowOnlinePayments">
                    <div class="body-2"> Tu plan actual no incluye cobros en línea.</div>
                    ¿Necesitas esta característica?
                    <br/>
                    <buy-new-plan-btn/>
                </div>

                <template v-else>
                    <!-- ALERTAS -->
                    <v-layout wrap>
                        <v-flex xs12>
                            <provider-sub-title text="Importante"></provider-sub-title>
                        </v-flex>
                        <v-flex xs12 class="mb-3">
                            <v-alert color="secondary" outline :value="true" style="border-radius: 10px">
                                Es importante que estes seguro(a) de los datos a configurar, pues estos se le enviaran
                                al cliente para <b>que pueda pagar y acceder a su consulta</b> posteriormente.
                            </v-alert>
                        </v-flex>
                    </v-layout>
                    <!-- DATOS FLOW -->
                    <v-layout wrap>
                        <v-flex xs12 style="position: relative">
                            <provider-sub-title text="Integración con Flow"></provider-sub-title>
                            <v-icon color="secondary" @click="goToFlowRegister" style="position: absolute; top: -2px; left: 150px">mdi-open-in-new</v-icon>
                        </v-flex>
                        <v-layout wrap align-center>
                            <v-flex xs12 pa-1>
                                <v-text-field
                                    hide-details outline
                                    label="API KEY"
                                    :rules="requiredRule"
                                    v-model="flow_api_key"
                                    prepend-inner-icon="mdi-key-variant"
                                />
                            </v-flex>
                            <v-flex xs12 pa-1>
                                <v-text-field
                                    hide-details outline
                                    label="SECRET KEY"
                                    :rules="requiredRule"
                                    v-model="flow_secret_key"
                                    prepend-inner-icon="mdi-key"
                                />
                            </v-flex>
                        </v-layout>
                    </v-layout>
                    <!-- VALORES POR ESPECIALIDAD -->
                    <v-layout wrap mt-3>
                        <v-flex xs12>
                            <provider-sub-title text="Valor por Especialidad"></provider-sub-title>
                        </v-flex>
                        <v-layout wrap align-center>
                            <v-flex xs6 pa-1 v-for="(specialty,i) in specialties" :key="i">
                                <v-text-field
                                    hide-details outline
                                    :label="specialty.name"
                                    :rules="requiredRule"
                                    :value="specialty.price | number"
                                    @input="value => specialty.price = value"
                                />
                            </v-flex>
                        </v-layout>
                    </v-layout>
                    <!-- CONTACTO -->
                    <v-layout wrap mt-3>
                        <v-flex xs12>
                            <provider-sub-title style="margin-bottom: 0 !important" text="Contacto"/>
                            <div class="caption py-0">¿A quién contactamos en caso de problemas?</div>
                        </v-flex>
                        <v-layout wrap class="mt-3">
                            <v-flex xs12 md6 pa-1>
                                <v-text-field
                                    clearable hide-details outline
                                    label="Nombre completo"
                                    :rules="nameRules"
                                    v-model="contact_full_name"
                                >
                                    <template v-slot:prepend-inner="">
                                        <v-icon size="22" class="mr-1">fa-user</v-icon>
                                    </template>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 pa-1>
                                <v-select
                                    hide-details outline
                                    label="Cargo"
                                    :rules="[v => !!v || 'Campo obligatorio']"
                                    :value="contact_job_title"
                                    v-model="contact_job_title"
                                    :items="jobTitles"
                                >
                                    <template v-slot:prepend-inner="">
                                        <v-icon size="22" class="mr-1">fa-suitcase</v-icon>
                                    </template>
                                </v-select>
                            </v-flex>
                            <v-flex xs12 md6 pa-1>
                                <v-text-field
                                    clearable hide-details outline
                                    label="E-mail" type="email"
                                    :rules="emailRules"
                                    v-model="contact_email"
                                >
                                    <template v-slot:prepend-inner="">
                                        <v-icon size="22" class="mr-1">fa-envelope</v-icon>
                                    </template>
                                </v-text-field>
                            </v-flex>
                            <v-flex xs12 md6 pa-1>
                                <v-text-field
                                    clearable hide-details outline
                                    label="Teléfono" :rules="phoneRules"
                                    v-model="contact_phone"
                                >
                                    <template v-slot:prepend-inner="">
                                        <v-icon size="22" class="mr-1">fa-phone</v-icon>
                                    </template>
                                </v-text-field>
                            </v-flex>
                        </v-layout>
                    </v-layout>
                </template>


            </v-card-text>
            <v-card-actions v-if="allowOnlinePayments && isOwner">
                <v-spacer></v-spacer>
                <v-btn :disabled="!valid" color="primary" @click="submit" :loading="loading">
                    Guardar
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-form>
</template>

<script>

import {mapState, mapMutations, mapGetters} from 'vuex'
import {ApiUtils} from '@/utils/ApiUtils'

export default {
    components: {
        ProviderSubTitle: () => import('@/components/providers/panel/ProviderSubTitle'),
        BuyNewPlanBtn: () => import('@/components/subscription/BuyNewPlanBtn'),
        ProviderTitle: () => import('@/components/providers/panel/ProviderTitle'),
    },
    props: {},
    data() {
        return {
            loading: false,
            valid: false,
            emailRules: [
                v => !!v && /.+@.+/.test(v) || 'E-mail inválido'
            ],
            phoneRules: [
                v => /^\+[0-9]{11}$/.test(v) || 'Teléfono inválido'
            ],
            nameRules: [
                v => !!v || 'Campo obligatorio',
                v => !!v && v.length > 2 || 'Mínimo 2 caracteres'
            ],
            requiredRule: [
                v => !!v || 'Campo obligatorio',
            ],

            flow_api_key: '',
            flow_secret_key: '',
            contact_full_name: '',
            contact_job_title: '',
            contact_email: '',
            contact_phone: '+56',
            specialties: []
        }
    },
    async mounted() {
        await ApiUtils.fetchMe()
        this.loadDefault()
    },
    computed: {
        ...mapState(['currentUser', 'currentProvider', 'currentBranchOffice']),
        ...mapGetters(['allowOnlinePayments']),
        jobTitles() {
            return ['Dueño', 'Contador(a)', 'Otro']
        },
        payload(vm = this) {
            return {
                flow_api_key: vm.flow_api_key.trim() || '',
                flow_secret_key: vm.flow_secret_key.trim() || '',
                contact_full_name: vm.contact_full_name || '',
                contact_job_title: vm.contact_job_title || 'Dueño',
                contact_email: vm.contact_email || '',
                contact_phone: vm.contact_phone || '+56',
                specialties: vm.specialties.map(specialty => ({
                    id: specialty.id,
                    price: Number(specialty.price.toString().replaceAll('.', ''))
                })),
            }
        },
    },
    methods: {
        ...mapMutations(['showSnackBar']),
        loadDefault() {
            const vm = this
            const {settings: {payment_account}, specialties} = vm.currentProvider

            if (specialties) {
                vm.specialties = specialties.map(specialty => ({
                    id: specialty.pivot.id,
                    name: specialty.description,
                    price: specialty.pivot.price || ''
                }))
            }

            vm.flow_api_key = payment_account && payment_account.flow_api_key || ''
            vm.flow_secret_key = payment_account && payment_account.flow_secret_key || ''
            vm.contact_full_name = payment_account && payment_account.contact_full_name || ''
            vm.contact_job_title = payment_account && payment_account.contact_job_title || 'Dueño'
            vm.contact_email = payment_account && payment_account.contact_email || ''
            vm.contact_phone = payment_account && payment_account.contact_phone || '+56'
        },
        async submit() {
            const vm = this
            if (!vm.valid) return
            vm.loading = true
            const response = await ApiUtils.makePost(`provider/${vm.currentProvider.id}/payment/account`, vm.payload)
            if (!response.ok) {
                this.loading = false
                const json = await response.json()
                return vm.$store.commit('showSnackBar', {
                    text: json.message || 'Error intentando procesar la solicitud',
                    color: 'error'
                })
            }
            await ApiUtils.fetchMe()
            vm.loading = false
            return vm.$store.commit('showSnackBar', {text: 'Datos de pago guardados', color: 'success'})
        },
        goToFlowRegister() {
            window.open('https://www.flow.cl/app/web/misDatos.php')
        }
    },
}
</script>
<style scoped>


</style>